import {useState, useEffect} from "react";
import Navbar from "../../components/layout/navbar";
import useRequest from "../../components/hooks/use-request";
import Button from "../../components/button";
import { Plus } from "lucide-react";
import DiscountCard from "./discount-card";
import Discount from "./discount";
import AddDiscountDialog from "../../components/discount/add-discount-dialog";
import Pagination from "../../components/pagination";




interface ProfileData {
    username: string;
    email: string;
    phone: string;
    address: string;
    lastLogin: string;
}

interface MetricsData {
  totalActive: number;
  totalDiscountAvailable: number;
  totalUpcoming: number;
  totalExpired: number;
  totalPending: number;
}
const Promotions = () => {

    const [profile, setProfile] = useState<ProfileData | null>(null);
    const [orderModal, setOrderModal] = useState(false);
    const [metrics, setMetrics] = useState<MetricsData | null>(null);
    const [discount, setDiscount] = useState<[]>([]);
    const params = new URLSearchParams(new URL(window.location.href).search);
    const [currentPage, setCurrentPage] = useState(
      Number(params.get("page") || 1)
    );
    const [totalPages, setTotalPages] = useState<number>(1);
    const [totalDocs, setTotalDocs] = useState<number>(0);
    const [currentPageItems, setCurrentPageItems] = useState<number>(0);
    const itemsPerPage = 10;

    const userToken = localStorage.getItem("token");

    const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getMetrics } = useRequest("/discounts/metrics", "GET", {
    Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getPromotions } = useRequest("/discounts", "GET", {
        Authorization: `Bearer ${userToken}`,
    });


    useEffect(() => {
        const fetchProfile = async () => {
          const [response] = await getProfile();
          if (response.status) {
            setProfile(response.data?.user);
          }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        const fetchMetrics = async () => {
          const [response] = await getMetrics();
          if (response.status) {
            setMetrics(response.data.data);
          }
        };
        fetchMetrics();
    }, []);

    // useEffect(() => {
    //     const fetchSuppliers = async () => {
    //       const [response] = await getPromotions();
    //       if (response.status) {
    //         setDiscount(response.data?.discounts?.docs);
    //       }
    //     };
    //     fetchSuppliers();
    //   }, []);

    function updateUrlParams(params: { [key: string]: string | number | null }) {
      const url = new URL(window.location.href);
  
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.set(key, params[key]!.toString());
        } else {
          url.searchParams.delete(key);
        }
      });
  
  
  
      window.history.pushState({}, "", url.toString());
    }
    
    useEffect(() => {
      updateUrlParams({
        page: currentPage !== 1 ? currentPage : null,
      });
      fetchOrders();
    }, [currentPage]);

    async function fetchOrders() {
      const page = currentPage;
      const limit = itemsPerPage;
  
      const [response] = await getPromotions(undefined, {
        limit,
        page,
      });
  
      if (response.status && response.data?.discounts) {
        setDiscount(response.data.discounts.docs || []);
        setTotalPages(response.data.discounts.totalPages || 1);
        setTotalDocs(response.data.discounts.totalDocs || 0);
        setCurrentPageItems(response.data.discounts.docs?.length || 0);
      }
    }


    function closePromotionModal() {
      setOrderModal(false);
    }
  
    function openPromotionModal() {
      setOrderModal(true);
    }

    async function handlePageChange(page: number) {
      setCurrentPage(page);
    }
  
    return ( 
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar profile={profile as ProfileData} />

            <main className="flex-1 container mx-auto py-6">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
                    <div className="mb-4 sm:mb-0">
                        <h1 className="text-[30px] font-extrabold text-black">
                          Promo and Discounts
                        </h1>
                        <p className="text-[#676767] text-[18px] font-normal">
                            Manage and Monitor Active Promotions and Discounts
                        </p>
                    </div>
                    <div className="flex gap-2">
                      <button className="rounded-full border px-4 py-1">Export</button>

                      <Button
                      size="lg"
                      variant="primary"
                      type="button"
                      className="font-normal md:mt-0 mt-6"
                      onClick={openPromotionModal}
                      >
                      <Plus /> Create Discount
                      </Button>
                    </div>
                </div>

                {metrics && <DiscountCard metrics={metrics}/>}
                <Discount data={discount}/>

                {totalPages > 1 && (
                  <div className="mt-4">
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      totalDocs={totalDocs}
                      totalItems={currentPage === totalPages ? totalDocs : currentPageItems}
                    />
                  </div>
                )}
            </main>

            <AddDiscountDialog
                isVisible={orderModal}
                onClose={closePromotionModal}
                discount={discount}
            
            />
        </div>
     );
}
 
export default Promotions;